import React, { PropTypes, Component } from 'react';
import LeftBarDetail from './left-bar-detail';

class Passengers extends Component {

  render() {
    const {
      profileToShow,
      editField,
      isEditable,
    } = this.props;
    const minMaxPassengersNodes = [];

    if (profileToShow.totalMaxPassengers !== undefined || isEditable) {
      minMaxPassengersNodes.push(
        <LeftBarDetail
          key="max"
          isEditable={isEditable}
          infoToDisplay={profileToShow.totalMaxPassengers}
          classification="MAX"
          itemName="Max Passengers"
          className="segment-content"
          editField={editField.bind(this, 'totalMaxPassengers', { type: 'number', isRequired: true })}
          inline
          noMargin
        />
      );
    }

    if (profileToShow.totalMinPassengers !== undefined || isEditable) {
      minMaxPassengersNodes.push(
        <LeftBarDetail
          key="min"
          isEditable={isEditable}
          infoToDisplay={profileToShow.totalMinPassengers}
          classification="MIN"
          itemName="Min Passengers"
          className="segment-content"
          editField={editField.bind(this, 'totalMinPassengers', { type: 'number', isRequired: true })}
          noMargin
          inline
        />
      );
    }

    return (
      <div style={{ marginTop: '32px' }} id="passengers">
        <div className="description-segments">
          <span className="description-segments-titel">PASSENGERS</span>
        </div>
        <div className="l-paper-split-segment">
          {minMaxPassengersNodes}
        </div>
      </div>
    );
  }
}

Passengers.propTypes = {
  profileToShow: PropTypes.object,
  editField: PropTypes.func,
  isEditable: PropTypes.bool,
};

export default Passengers;



// WEBPACK FOOTER //
// ./src/app/components/profile/profile-left-bar/passengers.jsx